<template>
  <div>
    <v-card>
      <v-card-title :style="getThemeStyle">
        {{ title }}
        <v-switch
          v-model="switchValue"
          class="ml-10"
          label="All"
          dark
          @change="getSwitchValue()"
        ></v-switch>
        <v-spacer></v-spacer>
        <v-text-field
          dark
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        >
        </v-text-field>
      </v-card-title>
      <v-data-table
        @input="getSelectedItems"
        v-model="selectedItems"
        show-select
        :headers="headers"
        :items="newItems"
        :search="search"
        :items-per-page="itemsPerPage"
      >
        <template
          v-for="column in headers"
          v-slot:[`item.${column.value}`]="{ item, headers }"
        >
          <v-icon
            v-if="column.value == 'selection'"
            :key="column.value"
            color="red"
            @click="openConfirmDeleteDialog(item.id)"
          >
            mdi-delete
          </v-icon>
          <span
            v-else-if="column.value == 'id'"
            :key="column.value"
            color="red"
          >
            {{ item[column.value] }}
          </span>

          <ForeignKeyField
            v-else-if="
              foreignKeysArray &&
              foreignKeysArray.length > 0 &&
              foreignKeysArray.includes(column.value)
            "
            :key="column.value"
            :foreignColumn="column.value"
            :foreignTablesArray="foreignTablesArray"
            :foreignKeysArray="foreignKeysArray"
            :foreignFieldValue="item[column.value]"
            :branchID="null"
            @field-selected="getSelectedForeignData($event, column.value, item)"
          ></ForeignKeyField>

          <vInputField
            v-else
            :key="column.value"
            :defaultValue="
              item[column.value] && monies.includes(column.value)
                ? getCurrency + ' ' + axios.formatMoney(item[column.value])
                : item[column.value]
            "
            :label="column.value"
            @input-updated="updateInputField($event, item.id, column.value)"
          >
          </vInputField>
        </template>
      </v-data-table>
    </v-card>
    <ConfirmDeleteDialog
      :item="'Selected Item(s)'"
      @delete-confirmed="deleteItemsNow"
    ></ConfirmDeleteDialog>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import ForeignKeyField from "@/components/General/ForeignKeyField.vue";
import vInputField from "./vInputField.vue";
import helpersJs from "@/plugins/helpers";
import ConfirmDeleteDialog from "@/components/General/ConfirmDeleteDialog.vue";

export default {
  components: {
    vInputField,
    ConfirmDeleteDialog,
    ForeignKeyField,
  },
  watch: {
    items(newVal) {
      this.newItems = [];
      this.newItems = newVal;
    },
    headersProp(newHeader) {
      this.headers = newHeader;
    },
  },
  mounted() {
    this.axios = axios;
    this.newItems = this.items;
    this.headers = this.headersProp;
  },
  computed: {
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
    getThemeStyle() {
      return this.$store.getters.getThemeStyle;
    },
  },
  props: {
    table: {
      default: null,
    },
    editable: {
      default: true,
    },
    title: {
      default: "Data Title",
    },
    items: {
      default: () => [],
    },
    headersProp: {
      default: () => [],
    },
    height: {
      default: "400px",
    },
    foreignTablesArray: {
      default: () => [],
    },
    foreignKeysArray: {
      default: () => [],
    },
    itemsPerPage: {
      default: 50,
    },
  },
  data: () => ({
    axios: null,
    headers: [],
    monies: [
      "pledges",
      "donations",
      "tithes",
      "offering",
      "offerings",
      "amount",
    ],
    search: "",
    selectedItems: [],
    switchValue: false,
    newItems: [],
    selectedItemID: null,
  }),
  methods: {
    formatTableName(name) {
      return helpersJs.formatUnderscoreNamesWithFirstCapitalLetters(name);
    },
    async updateInputField(newValue, id, column) {
      await helpersJs.updateModelSingleRow(this.table, column, id, newValue);
      this.$emit("field-updated", [newValue, id, column]);
      this.$toast.success("Field Updated Successfully!", {
        duration: 3000,
      });
    },
    async getSelectedForeignData($event, column, item) {
      const value = $event[0];
      const rowID = item.id;
      await helpersJs.updateModelSingleRow(this.table, column, rowID, value);

      this.$emit("branch-selected", [$event, item]);
      this.$toast.success("Field Updated Successfully!", {
        duration: 3000,
      });
    },
    getSelectedItems() {
      this.selectedItemID = null;
      this.$emit("selection-made", this.selectedItems);
    },
    openConfirmDeleteDialog(id) {
      this.selectedItemID = id;
      this.$store.commit("setConfirmDelete", true);
    },
    getSwitchValue() {
      this.selectedItemID = null;
      this.selectedItems = [];

      if (this.switchValue) {
        this.items.forEach((item) => {
          this.selectedItems.push(item);
        });
      }
      this.$emit("selection-made", this.selectedItems);
    },
    async deleteItemsNow(choice) {
      if (choice) {
        this.$store.commit("setLoader", true);
        if (this.selectedItemID) {
          await helpersJs.deleteSingleRow(this.table, this.selectedItemID);
          this.$emit("item-deleted", this.selectedItemID);
        } else {
          await helpersJs.deleteMultipleRows(this.table, this.selectedItems);
          this.$emit("item-deleted", this.selectedItems);
        }
        this.$store.commit("setLoader", false);
        this.closeDialog();
        this.$toast.success("Item Deleted Successfully!", { duration: 3000 });
      }
    },
    closeDialog() {
      this.selectedItemID = null;
      this.selectedItems = [];
      this.$store.commit("setConfirmDelete", false);
    },
  },
};
</script>

<style></style>
